import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ClientTeamMember } from '../generated/graphql';

import { AppState } from './store';

interface UnknownGuestState {
  unknownGuest: ClientTeamMember | null;
}

const initialState: UnknownGuestState = {
  unknownGuest: null,
};

const unknownGuestSlice = createSlice({
  name: 'unknownGuest',
  initialState,
  reducers: {
    setUnknownGuest: (
      state,
      action: PayloadAction<ClientTeamMember | null>,
    ) => {
      state.unknownGuest = action.payload;
    },
    clearUnknownGuest: (state) => {
      state.unknownGuest = null;
    },
  },
});

export const { setUnknownGuest, clearUnknownGuest } = unknownGuestSlice.actions;

// Selectors
export const selectUnknownGuest = (state: AppState) =>
  state.unknownGuest.unknownGuest;

export const unknownGuestReducer = unknownGuestSlice.reducer;
